module.exports = "/fonts/Gineso-Norm-Light.otf";